import React from 'react'

import { FieldError, FieldState } from 'components/_new/forms'


const FieldStateError = ({ field }) => (
  <FieldState field={field}>
    {
      ({ error }) => Boolean(error) && (
        <FieldError message={error} />
      )
    }
  </FieldState>
)


export default FieldStateError
